module.exports = __webpack_public_path__ + "open-sans-latin-700.0ac670c8d196545bda6a.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-700.woff2
// module id = ../../../../typeface-open-sans/files/open-sans-latin-700.woff2
// module chunks = 1 3